module.exports = __webpack_public_path__ + "static/media/FFO12_EDITSINGLE.1ccf2d05.mp4";